import { render, staticRenderFns } from "./setOrder.vue?vue&type=template&id=7f48b312&"
import script from "./setOrder.vue?vue&type=script&lang=js&"
export * from "./setOrder.vue?vue&type=script&lang=js&"
import style0 from "./setOrder.vue?vue&type=style&index=0&id=7f48b312&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports